export default __webpack_public_path__ + "static/media/imprint-image.c81b80da.svg";